module.exports = __webpack_public_path__ + "static/img/Bachelor_010429.7071779.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010429.jpg
// module id = 164
// module chunks = 0